<!--
 * @Description: 品牌宣传
 * @Author: xiawenlong
 * @Date: 2026-04-02
-->

<template>
  <div class="BrandPromotion">
    <div class="title">
      <span>品牌宣传</span>
      <!-- <div class="date-range">
        <a-range-picker
          v-model="dateRange"
          :format="dateFormat"
          :placeholder="['开始日期', '结束日期']"
          @change="onDateChange"
        />
      </div> -->
    </div>
    <div class="content">
      <div class="charts-row">
        <div class="pie-chart-container">
          <div class="chart-title">粉丝数量</div>
          <div id="fansPieChart"></div>
        </div>
        <div class="pie-chart-container">
          <div class="chart-title">视频/文章数量</div>
          <div id="contentPieChart"></div>
        </div>
      </div>
      <div class="bar-chart-container">
        <div id="horizontalBarChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
// import { DatePicker } from 'ant-design-vue'
import moment from 'moment'
import { brandPublicityList } from '@/api/agriculture-dashboard'

let fansPieChart, contentPieChart, horizontalBarChart

export default {
  // components: {
  //   'a-range-picker': DatePicker.RangePicker,
  // },
  data() {
    return {
      dateFormat: 'YYYY-MM',
      dateRange: [moment('2025-01', 'YYYY-MM'), moment('2025-12', 'YYYY-MM')],
      chartData: {
        fansData: [],
        contentData: [],
        barData: {
          platforms: [],
          viewData: [],
          likeData: [],
        },
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initCharts()
      this.loadData(this.dateRange[0], this.dateRange[1])
    })
    window.addEventListener('resize', () => {
      if (fansPieChart) fansPieChart.resize()
      if (contentPieChart) contentPieChart.resize()
      if (horizontalBarChart) horizontalBarChart.resize()
    })
    this.startPieChartPolling()
    this.pollingTimer = setInterval(() => {
      this.loadData(this.dateRange[0], this.dateRange[1])
    }, process.env.VUE_APP_LTIME)
  },
  beforeDestroy() {
    if (fansPieChart) {
      fansPieChart.dispose()
      fansPieChart = null
    }
    if (contentPieChart) {
      contentPieChart.dispose()
      contentPieChart = null
    }
    if (horizontalBarChart) {
      horizontalBarChart.dispose()
      horizontalBarChart = null
    }
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
    }
    this.stopPieChartPolling()
  },
  methods: {
    initCharts() {
      const fansDom = document.getElementById('fansPieChart')
      const contentDom = document.getElementById('contentPieChart')
      const barDom = document.getElementById('horizontalBarChart')

      if (fansDom) fansPieChart = echarts.init(fansDom)
      if (contentDom) contentPieChart = echarts.init(contentDom)
      if (barDom) horizontalBarChart = echarts.init(barDom)
    },
    onDateChange(dates) {
      if (dates && dates.length === 2) {
        this.loadData(dates[0], dates[1])
      }
    },
    async loadData(startDate, endDate) {
      try {
        const params = {
          startTime: startDate.format('YYYY-MM'),
          endTime: endDate.format('YYYY-MM'),
        }
        const res = await brandPublicityList(params)
        if (res.code === 0 && res.data) {
          this.processChartData(res.data)
        }
      } catch (error) {
        console.error('获取品牌宣传数据失败:', error)
      }
    },
    processChartData(data) {
      const platformColors = {
        小红书: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
          { offset: 0, color: '#FF5555' },
          { offset: 1, color: '#FF2020' },
        ]),
        抖音: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
          { offset: 0, color: '#00E0B0' },
          { offset: 1, color: '#00B890' },
        ]),
        视频号: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
          { offset: 0, color: '#F59E0B' },
          { offset: 1, color: '#D97706' },
        ]),
        公众号: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
          { offset: 0, color: '#A855F7' },
          { offset: 1, color: '#7C3AED' },
        ]),
      }

      const platforms = ['小红书', '抖音', '视频号', '公众号']

      // Process pie chart data
      const fansData = []
      const contentData = []

      // Process bar chart data
      const viewData = []
      const likeData = []

      platforms.forEach(platform => {
        const item = data.find(d => d.platformType === platform)
        if (item) {
          fansData.push({
            name: platform,
            value: item.fansCount || 0,
            itemStyle: {
              color: platformColors[platform],
            },
          })
          contentData.push({
            name: platform,
            value: item.contentCount || 0,
            itemStyle: {
              color: platformColors[platform],
            },
          })
          viewData.push(item.viewCount || 0)
          likeData.push(item.likeCommentCount || 0)
        } else {
          fansData.push({
            name: platform,
            value: 0,
            itemStyle: {
              color: platformColors[platform],
            },
          })
          contentData.push({
            name: platform,
            value: 0,
            itemStyle: {
              color: platformColors[platform],
            },
          })
          viewData.push(0)
          likeData.push(0)
        }
      })

      this.chartData.fansData = fansData
      this.chartData.contentData = contentData
      this.chartData.barData.platforms = [...platforms].reverse()
      this.chartData.barData.viewData = [...viewData].reverse()
      this.chartData.barData.likeData = [...likeData].reverse()

      this.updatePieCharts()
      this.updateBarChart()
    },
    updatePieCharts() {
      const pieOption = data => ({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderColor: 'rgba(68, 240, 233, 0.46)',
          textStyle: {
            color: '#fff',
          },
          formatter: '{b}: {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'center',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 15,
          textStyle: {
            color: '#fff',
            fontSize: 14,
          },
          icon: 'rect',
        },
        series: [
          {
            type: 'pie',
            radius: ['0%', '70%'],
            center: ['35%', '50%'],
            roseType: 'radius',
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 5,
              borderColor: '#001E3C',
              borderWidth: 0,
            },
            label: {
              show: true,
              position: 'outside',
              color: '#fff',
              fontSize: 14,
              formatter: '{c}',
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 10,
              lineStyle: {
                color: '#fff',
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold',
              },
            },
            data: data.sort(function(a, b) {
              return b.value - a.value
            }),
          },
        ],
      })

      if (fansPieChart) {
        fansPieChart.setOption(pieOption(this.chartData.fansData))
      }
      if (contentPieChart) {
        contentPieChart.setOption(pieOption(this.chartData.contentData))
      }
    },
    updateBarChart() {
      const barOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderColor: 'rgba(68, 240, 233, 0.46)',
          textStyle: {
            color: '#fff',
          },
        },
        legend: {
          data: ['点赞/评论数量（万）', '播放/阅读数量（万）'],
          bottom: 0,
          itemWidth: 14,
          itemHeight: 10,
          itemGap: 20,
          textStyle: {
            color: '#fff',
            fontSize: 14,
          },
          icon: 'rect',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          top: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          data: this.chartData.barData.platforms,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            color: '#fff',
            fontSize: 14,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: '点赞/评论数量（万）',
            type: 'bar',
            data: this.chartData.barData.likeData,
            barWidth: 30,
            barGap: '30%',
            itemStyle: {
              color: '#FFA500',
              borderRadius: [0, 0, 0, 0],
            },
            label: {
              show: true,
              position: 'insideLeft',
              color: '#fff',
              fontSize: 12,
            },
            stack: 'total',
          },
          {
            name: '播放/阅读数量（万）',
            type: 'bar',
            data: this.chartData.barData.viewData,
            barWidth: 30,
            itemStyle: {
              color: '#00BFFF',
              borderRadius: [0, 3, 3, 0],
            },
            label: {
              show: true,
              position: 'insideRight',
              color: '#fff',
              fontSize: 12,
            },
            stack: 'total',
          },
        ],
      }

      if (horizontalBarChart) {
        horizontalBarChart.setOption(barOption)
      }
    },
    startPieChartPolling() {
      this.stopPieChartPolling()
      this.currentHighlightIndex = 0
      this.highlightPieSlices()
      this.piePollingTimer = setInterval(() => {
        this.highlightPieSlices()
      }, 2000)
    },
    stopPieChartPolling() {
      if (this.piePollingTimer) {
        clearInterval(this.piePollingTimer)
        this.piePollingTimer = null
      }
    },
    highlightPieSlices() {
      const fansDataLen = this.chartData.fansData.length
      const contentDataLen = this.chartData.contentData.length

      if (fansDataLen > 0) {
        this.dispatchHighlight(fansPieChart, this.currentHighlightIndex % fansDataLen)
      }
      if (contentDataLen > 0) {
        this.dispatchHighlight(contentPieChart, this.currentHighlightIndex % contentDataLen)
      }

      this.currentHighlightIndex =
        (this.currentHighlightIndex + 1) % Math.max(fansDataLen, contentDataLen, 1)
    },
    dispatchHighlight(chart, dataIndex) {
      if (!chart) return

      chart.dispatchAction({
        type: 'downplay',
        seriesIndex: 0,
      })

      chart.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex: dataIndex,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.BrandPromotion {
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .title {
    position: relative;
    width: 100%;
    height: 70px;
    background: url('~@/img/agriculture/title_bg.png') 100% 100%;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 70px;
    padding-left: 47px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;

    span {
      position: relative;
      z-index: 9;
    }

    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 25px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }

    .date-range {
      display: flex;
      align-items: center;

      ::v-deep .ant-calendar-picker {
        .ant-calendar-picker-input {
          background: rgba(0, 30, 60, 0.8);
          border: 1px solid rgba(68, 240, 233, 0.46);
          border-radius: 4px;
          color: #fff;
          font-size: 14px;
          height: 32px;
          padding: 4px 11px;

          &::placeholder {
            color: rgba(255, 255, 255, 0.6);
          }

          .ant-calendar-range-picker-separator {
            color: #fff;
          }

          .ant-calendar-range-picker-input {
            color: #fff;
            background: transparent;
          }
        }

        .ant-calendar-picker-icon {
          color: #fff;
        }
      }
    }
  }

  .content {
    height: calc(100% - 70px);
    width: 100%;
    position: relative;
    padding: 20px 10px 10px 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .charts-row {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 50%;
      margin-bottom: 10px;

      .pie-chart-container {
        width: 50%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        #fansPieChart,
        #contentPieChart {
          width: 100%;
          height: 90%;
        }

        .chart-title {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          font-size: 14px;
          color: #fff;
          font-weight: bold;
        }
      }
    }

    .bar-chart-container {
      height: 45%;
      width: 100%;

      #horizontalBarChart {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
// 全局样式，用于日期选择器下拉面板
.ant-calendar-range {
  background: #0a1a2a !important;
  border: 1px solid #44f0e9 !important;
  box-shadow: 0 0 20px rgba(68, 240, 233, 0.3) !important;

  // 日期单元格
  .ant-calendar-date {
    color: #fff;
    background: transparent;

    &:hover {
      background: #44f0e9;
      color: #000;
    }
  }

  // 选中的日期
  .ant-calendar-selected-day .ant-calendar-date {
    background: #00d4aa;
    color: #000;
    font-weight: bold;
  }

  // 今天的日期
  .ant-calendar-today .ant-calendar-date {
    border-color: #44f0e9;
    color: #44f0e9;

    &:hover {
      color: #000;
    }
  }

  // 不在当前月的日期
  .ant-calendar-last-month-cell .ant-calendar-date,
  .ant-calendar-next-month-btn-day .ant-calendar-date {
    color: rgba(255, 255, 255, 0.3);
  }

  // 禁用的日期
  .ant-calendar-disabled-cell .ant-calendar-date {
    color: rgba(255, 255, 255, 0.2);
    background: transparent;
  }

  // 月份面板
  .ant-calendar-month-panel {
    background: #0a1a2a;
  }

  .ant-calendar-month-panel-month {
    color: #fff;
    background: transparent;

    &:hover {
      background: #44f0e9;
      color: #000;
    }
  }

  .ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {
    background: #00d4aa;
    color: #000;
    font-weight: bold;
  }

  // 年份面板
  .ant-calendar-year-panel {
    background: #0a1a2a;
  }

  .ant-calendar-year-panel-year {
    color: #fff;
    background: transparent;

    &:hover {
      background: #44f0e9;
      color: #000;
    }
  }

  .ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {
    background: #00d4aa;
    color: #000;
    font-weight: bold;
  }

  // 头部
  .ant-calendar-header {
    border-bottom: 1px solid #44f0e9;
    background: #0a1a2a;

    a {
      color: #fff;

      &:hover {
        color: #44f0e9;
      }
    }
  }

  .ant-calendar-month-panel-header {
    border-bottom: 1px solid #44f0e9;
    background: #0a1a2a;

    a {
      color: #fff;

      &:hover {
        color: #44f0e9;
      }
    }
  }

  .ant-calendar-year-panel-header {
    border-bottom: 1px solid #44f0e9;
    background: #0a1a2a;

    a {
      color: #fff;

      &:hover {
        color: #44f0e9;
      }
    }
  }

  // 切换按钮
  .ant-calendar-prev-year-btn,
  .ant-calendar-prev-month-btn,
  .ant-calendar-next-month-btn,
  .ant-calendar-next-year-btn,
  .ant-calendar-month-panel-prev-year-btn,
  .ant-calendar-month-panel-next-year-btn,
  .ant-calendar-year-panel-prev-year-btn,
  .ant-calendar-year-panel-next-year-btn,
  .ant-calendar-year-panel-prev-decade-btn,
  .ant-calendar-year-panel-next-decade-btn {
    color: #fff;

    &:hover {
      color: #44f0e9;
    }
  }

  // 星期标题
  .ant-calendar-column-header {
    color: #44f0e9;
    font-weight: bold;
  }

  // 底部
  .ant-calendar-footer {
    border-top: 1px solid #44f0e9;
    background: #0a1a2a;

    a {
      color: #44f0e9;

      &:hover {
        color: #00d4aa;
      }
    }
  }

  // 时间选择器
  .ant-calendar-time-picker-inner {
    background: #0a1a2a;

    .ant-calendar-time-picker-select {
      border-right: 1px solid #44f0e9;

      li {
        color: #fff;

        &:hover {
          background: #44f0e9;
          color: #000;
        }

        &.ant-calendar-time-picker-select-option-selected {
          background: #00d4aa;
          color: #000;
        }
      }
    }
  }

  // 快捷选择
  .ant-calendar-range-quick-selector {
    border-left: 1px solid #44f0e9;

    a {
      color: #44f0e9;

      &:hover {
        color: #00d4aa;
      }
    }
  }
}
</style>
